import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import OperationLogService from '../../services/Reports/DeviceCMDandOperationLogService';
const initialState = [];

export const getallOperationLogs = createAsyncThunk('operation_log', async (payload) => {
    const res = await OperationLogService.get(payload);
    return res.data;
});

export const getDeviceCommands = createAsyncThunk('device_commands', async (payload) => {
    const res = await OperationLogService.getCMD(payload);
    return res.data;
}); 

// const { reducer } = DeliveryReportSlice;
// export default reducer;